/**
 * Module dependencies
 */
const SPAContainer = require('./lib/SPAContainer');
const AsyncComponent = require('./lib/AsyncComponent');
const aphrodite = require('./lib/aphrodite');
const ReactRouterDom = require('react-router-dom');

const match = require('./lib/match');
const Routes = require('./lib/Routes');

/**
 * Expose SPA components
 */
exports.SPAContainer = SPAContainer;
exports.buildRoutes = AsyncComponent.buildRoutes;
exports.preloadReady = AsyncComponent.preloadReady;

// Styles
exports.StyleSheet = aphrodite.StyleSheet;
exports.css = aphrodite.css;

// React Router Dom
exports.Redirect = ReactRouterDom.Redirect;
exports.StaticRouter = ReactRouterDom.StaticRouter;
exports.Link = ReactRouterDom.Link;

// Custom implementations
exports.Routes = Routes;
exports.match = match;
